import { store } from 'src/redux/store';

export const FEATURE_FLAGS = {
  MENTIONS: 'messenger_mentions',
};

export const isFeatureFlagEnabled = (flag = '') => {
  const { profile } = store.getState();
  const { userInfo } = profile || {};

  const hasFeatureFlags = Array.isArray(userInfo?.featureFlags);
  if (!hasFeatureFlags) return false;

  return userInfo.featureFlags.includes(flag);
};
